export const SNACKBAR_SUCCESS_TYPE = 'success'
export const SNACKBAR_WARNING_TYPE = 'warning'
export const SNACKBAR_ERROR_TYPE = 'error'
export const SNACKBAR_INFO_TYPE = 'info'
